import axios from "axios";
import { ElMessage } from 'element-plus'

// 更新用户信息
export async function updateFun(params) {
    return new Promise((resolve, reject) => {
        axios.post("/adminapi/user/update", params, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }).then((res) => {
            if (res.data?.ActionType == "ok") {
                resolve(res.data);
                ElMessage({
                    showClose: true,
                    message: '更新成功！',
                    type: 'success',
                })
            } else {
                ElMessage.error(`更新失败：${res.data.msg}！`);
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}
// 添加用户
export async function userAddFun(params) {
    return new Promise((resolve, reject) => {
        axios.post("/api/bms/user", params).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
                ElMessage({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                })
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}
// 查询用户列表
export async function getUserListFun(params) {
    return new Promise((resolve, reject) => {
        let url = '/api/bms/user?';
        for (let i = 0; i < params.keys.length; i++) {
            const key = params.keys[i];
            if (params.formValue[key]) {
                if (i != 0) {
                    url += '&';
                }
                url += `${key}=${params.formValue[key]}`;
            }
        }
        axios.get(url).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}
// 删除用户
export async function deleteFun(id) {
    return new Promise((resolve, reject) => {
        axios.delete(`/api/bms/user/${id}`).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
                ElMessage({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                })
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}
// 清除微信绑定
export async function clearFun(id) {
    return new Promise((resolve, reject) => {
        axios.get(`/api/bms/user/clear/we/chat/binding/${id}`).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
                ElMessage({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                })
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}
// 根据_id查询数据详情
export async function getDetailFun(id) {
    return new Promise((resolve, reject) => {
        axios.get(`/api/bms/user/${id}`).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}
// 编辑
export async function editFun(params) {
    return new Promise((resolve, reject) => {
        axios.put(`/api/bms/user`, params).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
                ElMessage({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                })
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}

// 导出用户信息
export async function exportFun() {
    return new Promise((resolve, reject) => {
        axios.get(`/api/bms/user/export`, {
            headers: {
                Accept: 'application/octet-stream',
            },
            responseType: 'blob',
        }).then((res) => {
            resolve();
            const link = document.createElement('a');
            link.href = URL.createObjectURL(res.data);
            link.download = `用户信息.xlsx`;
            link.click();
            link.remove();
            ElMessage({
                showClose: true,
                message: "操作成功！",
                type: 'success',
            })
        }).catch(err => {
            reject(err);
        })
    })
}

// 查询审核列表列表
// 审核图片
